import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationResponse } from '@classes/notification/notification-response';
import { Pagination } from '@classes/pagination/pagination';
import { NotificationsService } from '@services/notifications.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  public notifications: NotificationResponse[] = [];
  public pagination: Pagination;
  public isLoading: boolean;

  constructor(
    private notificationsSrv: NotificationsService,
    private router: Router
  ) { }

  public ngOnInit(): void {
    this.initSubscriptions();
    this.isLoading = true;
    this.notificationsSrv.fetchNotifications();
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private initSubscriptions(): void {
    this.subscription.add(
      this.notificationsSrv.notificationsSubject
        .subscribe(notifications => {
          this.notifications = notifications;
        })
    );

    this.subscription.add(
      this.notificationsSrv.paginationSubject.subscribe(pagination => {
        this.pagination = pagination;
      })
    )

    this.subscription.add(
      this.notificationsSrv.loadingStateChanged
        .subscribe(loadingState => {
          this.isLoading = loadingState;
        })
    );
  }

  public onNotificationClick(notification: NotificationResponse): void {
    if (notification.type === 7) {
      this.router.navigate([`orders/${notification.payload.orderId}`]);
    }
    else if (notification.type === 5) {
      this.router.navigate([`orders/${notification.payload.id}`]);
    }
  }

  public clearOne(notification: NotificationResponse): void {
    this.notificationsSrv.removeOne(notification);
    if (this.notifications.length === 0) {
      this.notificationsSrv.backToFirstPage();
    }
  }

  public onClear(): void {
    this.notificationsSrv.clearNotifications();
  }

  public fetchNextPage(): void {
    this.notificationsSrv.fetchNextPage();
  }

  public fetchPreviousPage(): void {
    this.notificationsSrv.fetchPreviousPage();
  }

  public hasNextPage(): boolean {
    return this.notificationsSrv.hasNextPage();
  }

  public hasPreviousPage(): boolean {
    return this.notificationsSrv.hasPreviousPage();
  }
}
